var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_606_1337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4792 2.75H2.52083C1.13025 2.75 0 3.88025 0 5.27083V16.7292C0 18.1198 1.13025 19.25 2.52083 19.25H19.4792C20.8698 19.25 22 18.1198 22 16.7292V5.27083C22 3.88025 20.8698 2.75 19.4792 2.75ZM6.875 6.41667C8.13817 6.41667 9.16667 7.44517 9.16667 8.70833C9.16667 9.9715 8.13817 11 6.875 11C5.61183 11 4.58333 9.9715 4.58333 8.70833C4.58333 7.44517 5.61183 6.41667 6.875 6.41667ZM11 14.8958C11 15.2753 10.692 15.5833 10.3125 15.5833H3.4375C3.058 15.5833 2.75 15.2753 2.75 14.8958V14.4375C2.75 13.0469 3.88025 11.9167 5.27083 11.9167H8.47917C9.86975 11.9167 11 13.0469 11 14.4375V14.8958ZM18.5625 15.5833H13.5208C13.1413 15.5833 12.8333 15.2753 12.8333 14.8958C12.8333 14.5163 13.1413 14.2083 13.5208 14.2083H18.5625C18.942 14.2083 19.25 14.5163 19.25 14.8958C19.25 15.2753 18.942 15.5833 18.5625 15.5833ZM18.5625 11.9167H13.5208C13.1413 11.9167 12.8333 11.6087 12.8333 11.2292C12.8333 10.8497 13.1413 10.5417 13.5208 10.5417H18.5625C18.942 10.5417 19.25 10.8497 19.25 11.2292C19.25 11.6087 18.942 11.9167 18.5625 11.9167ZM18.5625 8.25H13.5208C13.1413 8.25 12.8333 7.942 12.8333 7.5625C12.8333 7.183 13.1413 6.875 13.5208 6.875H18.5625C18.942 6.875 19.25 7.183 19.25 7.5625C19.25 7.942 18.942 8.25 18.5625 8.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_606_1337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoProfile);
export default __webpack_public_path__ + "static/media/ico-profile.7ca2ac0955650b495c6d834bd198fb67.svg";
export { ForwardRef as ReactComponent };